import Dotdotdot from 'react-dotdotdot';

import { Box } from '@hivebrite/design-system/Box';

import decodeString from 'hb-react/shared/utils/decodeString';

import { Label, Value } from '../Styling';

interface SkillsProps {
  skills: null | string[];
}

const Skills = ({ skills }: SkillsProps) => (
  <Box data-testid="skills-block" mt="6px" flexDirection="column">
    <Label>{s__('Mentoring|Skills')}</Label>
    <Dotdotdot clamp={2} data-testid="skills-block-content">
      <Value>
        {skills && skills.length > 0
          ? skills.map((skill) => decodeString(skill)).join(', ')
          : '-'}
      </Value>
    </Dotdotdot>
  </Box>
);

export default Skills;
